import React, { useState } from 'react';
import { Button, ConfirmDialog, InlineNotification } from '@ui';
import { translate } from '@utils/i18n';
import { namespace } from '../../constants';
import useConvertProposalRequest from '../../../hooks/useConvertProposalRequest';
/**
 * Tells the office that this proposal is a suppressed proposal request and offers the
 * single action that makes it an ordinary draft proposal.
 */
export default function ProposalRequestBanner({ proposalId, canConvert }) {
    const [isConfirming, setIsConfirming] = useState(false);
    const { convertProposalRequest } = useConvertProposalRequest(proposalId);
    const handleConfirm = () => {
        convertProposalRequest.mutate(undefined, { onSettled: () => setIsConfirming(false) });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InlineNotification, { className: "mb-2", variant: "info", title: translate('proposal_request.title', { namespace }), action: canConvert ? (React.createElement(Button, { disabled: convertProposalRequest.isLoading, onClick: () => setIsConfirming(true) }, translate('proposal_request.convert', { namespace }))) : undefined }, translate('proposal_request.body', { namespace })),
        React.createElement(ConfirmDialog, { isOpen: isConfirming, title: translate('proposal_request.confirm_title', { namespace }), description: translate('proposal_request.confirm_body', { namespace }), confirmLabel: translate('proposal_request.convert', { namespace }), loading: convertProposalRequest.isLoading, onConfirm: handleConfirm, onCancel: () => setIsConfirming(false) })));
}
